import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 50px;
  text-align: center;

  @media (min-width: 769px) {
    margin: 0 auto 100px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">What's Next?</h2>

      <h2 className="title">Get In Touch</h2>

      <p>
        Whether you need a penetration test, a vulnerability assessment, or security consulting, I'd
        love to hear from you.
      </p>

      <a className="email-link" href={`mailto:${email}`}>
        Contact me
      </a>

      <p style={{ marginTop: '20px', fontSize: 'var(--fz-sm)', fontFamily: 'var(--font-mono)' }}>
        or{' '}
        <a
          href="https://www.linkedin.com/in/danielbechenea/"
          target="_blank"
          rel="noreferrer"
          className="inline-link">
          connect with me on LinkedIn
        </a>
      </p>
    </StyledContactSection>
  );
};

export default Contact;
